import config from 'app-core/config';
import Data from 'app-core/Data';
import moment from 'moment';
import dataOperations from './data-operations';

const getAllOperations = () => ({
	sort: {
		text: config.getVueApp().$tCaption('Sort by'),
		hint: config.getVueApp().$tCaption('Will sort array items with by specified fields'),
		props: [{
			name: 'fields',
			text: config.getVueApp().$tCaption('Fields'),
			type: 'fieldChooser'
		}, {
			name: 'direction',
			text: config.getVueApp().$tCaption('Direction'),
			type: 'array',
			array: [{
				key: 'asc',
				text: config.getVueApp().$tCaption('Ascending')
			},{
				key: 'desc',
				text: config.getVueApp().$tCaption('Descending')
			}]
		}],
		default: {
			direction: 'asc'
		}
	},
	skip: {
		text: config.getVueApp().$tCaption('Skip'),
		hint: config.getVueApp().$tCaption('Will skip N first items of array'),
		props: [{
			name: 'value',
			type: 'number'
		}],
		default: {
			value: 0
		}
	},
	take: {
		text: config.getVueApp().$tCaption('Take'),
		hint: config.getVueApp().$tCaption('Will take N items of array'),
		props: [{
			name: 'value',
			type: 'number'
		}],
		default: {
			value: 10
		}
	},
	group: {
		text: config.getVueApp().$tCaption('Group'),
		hint: config.getVueApp().$tCaption('Will group array with selected dimensions and calculate summaries for specified aggregates'),
		props: [{
			name: 'dimensions',
			text: config.getVueApp().$tCaption('Dimensions'),
			type: 'fieldChooser'
		}, {
			name: 'aggregations',
			text: config.getVueApp().$tCaption('Aggregates'),
			type: 'fieldChooser',
		}, {
			name: 'aggregationType',
			type: 'array',
			text: config.getVueApp().$tCaption('Aggregation type'),
			array: [{
				key: 'min',
				text: config.getVueApp().$tCaption('Minimum')
			},{
				key: 'max',
				text: config.getVueApp().$tCaption('Maximum')
			},{
				key: 'sum',
				text: config.getVueApp().$tCaption('Sum')
			},{
				key: 'avg',
				text: config.getVueApp().$tCaption('Average')
			},{
				key: 'count',
				text: config.getVueApp().$tCaption('Count')
			}]
		}],
		default: {
			aggregationType: 'sum'
		}
	},
	filter: {
		text: config.getVueApp().$tCaption('Filter'),
		hint: config.getVueApp().$tCaption('Will filter array by condition'),
		props: [{
			name: 'filter',
			type: 'criteria'
		}],
		default: {
			filter: null
		}
	},
})

async function processListOptions(array, listOptions) {
	return dataOperations.processListOptions(array, listOptions);
}

function getTestData(arrayFields, numberOfRows) {
	numberOfRows = numberOfRows || 20;

	const result = [];
	for(let i = 0; i < numberOfRows; i++) {
		const fieldTypes = {};
		const row = {};
		arrayFields.map(field => {
			if (fieldTypes[field.dataType] === void 0) {
				fieldTypes[field.dataType] = 0;
			}

			if (fieldTypes[field.dataType] === 0) {
				switch(field.dataType) {
					case 'date':
						row[field.id] = moment().add('days', parseInt(Math.random() * 5 - 3)).format('YYYY-MM-DD');
						break;
					case 'number':
						row[field.id] = 100 * (i + 1);
						break;
					case 'boolean':
						row[field.id] = !parseInt(Math.round(Math.random()));
						break;
					default:
						row[field.id] = `${Data.capitalize(field.id)} ${i + 1}`;
						break;
				}
			} else {
				switch(field.dataType) {
					case 'date':
						row[field.id] = moment().add('days', parseInt(Math.random() * 5 - 3)).format('YYYY-MM-DD');
						break;
					case 'number':
						row[field.id] = Math.round(Math.random() * numberOfRows) * ((i % (parseInt(numberOfRows/2))) + 1) * 10;
						break;
					case 'boolean':
						row[field.id] = !parseInt(Math.round(Math.random()));
						break;
					default:
						row[field.id] = `${Data.capitalize(field.id)} ${i % (parseInt(numberOfRows/2)) + 1}`;
						break;
				}
			}

			fieldTypes[field.dataType] += 1;
		});
		result.push(row);
	}

	return result;
}

export {
	processListOptions,
	dataOperations,
	getAllOperations,
	getTestData
}

export default {
	processListOptions,
	dataOperations,
	getAllOperations,
	getTestData
}